module.exports = __webpack_public_path__ + "img/xzqg.b6ceac94.png";